function setGoodsTypes(state, goodsTypes) {
	state.goodsTypes = goodsTypes;
}

function set(state, fn) {
	if (fn)
		fn(state);
}

export default {
	setGoodsTypes,
	set
};